export const handleError = (error) => {
  if (error.response) {
    //Error of API
    if (error.response.status === 401) {
      //   logout();
      // console.log("Error of token", error);
      return {
        status: false,
        message:
          error.response.data.message ||
          "En este momento no se puede procesar su solicitud, intentelo más tarde.",
        statusCode: error.response.status,
      };
    }
    if (error.response.status === 950) {
      //Error de verificacion
      // console.log("Error of verification", error);
      return {
        status: false,
        message:
          error.response.data.message ||
          "En este momento no se puede procesar su solicitud, intentelo más tarde.",
        statusCode: error.response.status,
      };
    }
    // console.log("Error Messasge", error);
    return {
      status: false,
      message:
        error.response.data.message ||
        "En este momento no se puede procesar su solicitud, intentelo más tarde.",
      statusCode: error.response.status,
    };
  } else if (error.request) {
    // console.log("Error of connection 2", error);
    //Error of conection
    return {
      status: false,
      titleMessage: "No se pudo establecer conexón.",
      message: "Intentelo más tarde.",
      errorCode: error.code,
    };
  } else {
    //Error for Network
    // console.log("Network error 1", error);
    return {
      status: false,
      titleMessage: "No se pudo establecer conexón.",
      message: "Ocurrio un error mientras se procesaba su solicitud.",
      errorCode: error.code,
    };
  }
};
